import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import AboutUsBody1 from '../components/about-us/AboutUsBody1';
import AboutUsBody2 from '../components/about-us/AboutUsBody2';
import AboutUsBody3 from '../components/about-us/AboutUsBody3';
import AboutUsBody4 from '../components/about-us/AboutUsBody4';
import Footer from '../components/Footer';
import Loader from '../components/Loader'; // Import the Loader component

const AboutUs = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => {
      setIsLoading(false); // After 2 seconds, set loading to false
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  return (
    <>
      <Header />
      <br/><br/><br/>
      <div
        style={{
          background: 'linear-gradient(135deg, rgb(247, 248, 249) 50%, #29313F 50%)',
          minHeight: '100vh', // Ensure it takes up full height
          paddingTop: '40px', // Adds some top padding
          paddingBottom: '40px', // Adds some bottom padding
        }}
      >
        {isLoading ? (
          <Loader /> // Show loader while the page is loading
        ) : (
          <div style={{ padding: '0 20px' }}> {/* Adding side padding */}
          <br/><br/><br/>
            <AboutUsBody1 /><br/>
            <AboutUsBody2 /><br/>
            <AboutUsBody3 /><br/>
            <br />
            <AboutUsBody4 /><br/>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;
